import moment from 'moment';

/**
 * Classe responsável pela validação de um Date
 */
abstract class DateFormatValidator {
  /**
   * Realiza a validação do Date
   *
   * @param dateFormat Date a ser validado
   */
  public static isValid(date: string, [dateFormat]: [string]): boolean {
    return moment(date, dateFormat, true).isValid();
  }
}

export default DateFormatValidator;
